import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Onayiew from '../views/OnayView.vue'
import KitapListesi from '@/views/KitapListesi.vue'
const routes = [
  {
    path: '/',
    name: 'anasayfa',
    meta: {title:'Adalar Muzesi | Kütüphane'},
    component: HomeView
  },
  {
    path: '/mailonay/:kontrol',
    name: 'mailonay',
    meta: {title:'Adalar Muzesi | Kütüphane'},
    component:Onayiew
  },
  {
    path: '/kitap-listesi',
    name: 'kitaplistesi',
    meta: {title:'Adalar Muzesi | Kitap Listesi'},
    component:KitapListesi
  },
  {
    path: '/:pathMatch(.*)*',
    redirect:'/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next()
})
export default router
